import { FC } from "react";
import { Link } from "react-router-dom";
import { Button, Paper, Typography } from "@mui/material";
import ArrowRightOutlined from "@mui/icons-material/ArrowRightOutlined";

interface ILinkListProps {
  list: {
    title: string;
    links: {
      label: string;
      url: string;
      disabled: boolean;
    }[];
  };
}

const LinkList: FC<ILinkListProps> = ({ list }) => {
  const { title, links } = list;
  const disabled = links.every((link) => link.disabled);

  return (
    <Paper variant="LinkList">
      <Typography
        variant="subtitle1"
        component="h2"
        color={disabled ? "textDisabled" : "textPrimary"}
      >
        {title}
      </Typography>
      {links.map((link) => (
        <Button
          key={link.label}
          component={Link}
          variant="listButton"
          to={link.url}
          disabled={link.disabled}
          disableRipple
        >
          {link.label}
          <ArrowRightOutlined fontSize="large" color="action" />
        </Button>
      ))}
    </Paper>
  );
};

export default LinkList;
